import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { eur } from "../lib/format";
import { Button } from "./ui/button";

const COPERTURA = {
  coperto: ["Probabilmente coperto", "border-emerald-300 bg-emerald-50 text-emerald-800"],
  non_coperto: ["Probabilmente non coperto", "border-red-300 bg-red-50 text-red-800"],
  da_verificare: ["Da verificare", "border-amber-300 bg-amber-50 text-amber-800"],
};

export const AnalisiAI = ({ garanziaId, descrizione, km, onApply }) => {
  const [loading, setLoading] = useState(false);
  const [r, setR] = useState(null);

  const run = async () => {
    setLoading(true); setR(null);
    try { const { data } = await api.post("/ai/reclamo-analisi", { garanzia_id: garanziaId, descrizione, km: Number(km) || 0 }); setR(data); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setLoading(false); }
  };

  const [label, cls] = COPERTURA[r?.copertura] || COPERTURA.da_verificare;
  return (
    <div className="rounded-md border border-dashed border-[#B08D57]/40 bg-[#F4EDE1]/50 p-3 sm:col-span-2" data-testid="ai-analisi-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-sm"><b>Assistente reclami AI</b><span className="text-muted-foreground"> · Gemini analizza il guasto</span></div>
        <Button type="button" size="sm" variant="outline" onClick={run} disabled={loading || (descrizione || "").length < 5} data-testid="ai-analisi-btn">
          {loading ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Sparkles className="mr-1 h-4 w-4 text-[#B08D57]" />} Analizza
        </Button>
      </div>
      {r && (
        <div className="mt-3 space-y-2 text-sm" data-testid="ai-analisi-result">
          <div className="flex flex-wrap gap-2">
            <span className={`rounded-sm border px-2 py-0.5 text-xs font-semibold ${cls}`} data-testid="ai-copertura">{label}</span>
            <span className="rounded-sm border bg-white px-2 py-0.5 text-xs">Componente: <b>{r.componente}</b></span>
            <span className="rounded-sm border bg-white px-2 py-0.5 text-xs">Priorità: <b>{r.priorita}</b></span>
          </div>
          <p>{r.motivazione}</p>
          {r.causa_probabile && <p className="text-muted-foreground">Causa probabile: {r.causa_probabile}</p>}
          <p>Stima: ricambi <b>{eur(r.stima_ricambi)}</b> · manodopera <b>{eur(r.stima_manodopera)}</b></p>
          {r.controlli?.length > 0 && <ul className="list-disc pl-5 text-muted-foreground">{r.controlli.map((c) => <li key={c}>{c}</li>)}</ul>}
          <Button type="button" size="sm" onClick={() => onApply(r)} className="bg-[#B08D57] hover:bg-[#96764A]" data-testid="ai-analisi-apply-btn">Applica suggerimenti</Button>
          <div className="text-[11px] text-muted-foreground">Suggerimento indicativo generato da AI: la decisione finale spetta all'officina.</div>
        </div>
      )}
    </div>
  );
};
